document.querySelectorAll('.menu-item__children-child .reset').forEach(button => {
    button.addEventListener('click', function() {
        const thirdTierMenu = this.closest('.menu-item__children-child').querySelector('.menu-item__third-tier');
        if (!thirdTierMenu) return;

        const isCollapsed = thirdTierMenu.getAttribute('data-collapsed') === 'true';
        thirdTierMenu.setAttribute('data-collapsed', !isCollapsed);

        const svg = this.querySelector('svg');
        if (svg) {
            svg.style.transform = isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)';
        }
    });
});
